


























import { Vue, Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import Tips from "@/components/common/index/Tips.vue";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivitySwitch from "@/components/common/edit/ActivitySwitch.vue";

import { Tip } from "@/common/interface";
import { majorNoticeText } from "@/common/constants/index";

const smsVerficationTips = {
  title: "短信验证功能说明",
  content: `
        <p>1、若家长无法正常获取验证码，请机构主账号前往【机构设置—短信管理】页查看短信余额是否充足，家长号码是否正确、号码是否已欠费停机。</p>
        <p>2、活动进行中，若剩余可发送短信数为0，家长报名时，会提示“当前无法发送短信验证码，请联系机构处理”。家长将不能获取验证码，<span style="color: #FF4F34">无法进行报名操作</span>。充值后短信验证功能可正常使用，机构可前往短信管理页面进行短信充值，或前往小麦秀活动编辑页面关闭短信验证功能。</p>
      `,
};

@Component({
  components: {
    tips: Tips,
    "dash-line": DashLine,
    "activity-switch": ActivitySwitch,
  },
})
export default class SMSVerfication extends Vue {
  @Getter("hasOpenSMSVerify") hasOpenSMSVerify!: boolean;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("xmMajordomo") xmMajordomo!: boolean;
  @Getter("xcxType") xcxType!: string;
  @Getter("hasInstOpenSMSVerify") hasInstOpenSMSVerify!: boolean;
  @Getter("smsRemainNumber") smsRemainNumber!: number;
  @Getter("instNameNot") instNameNot!: any;
  @Getter("instNameFew") instNameFew!: any;
  @Getter("instNameZero") instNameZero!: any;

  @Action("switchSMSVerify") switchSMSVerify!: Function;

  smsVerficationTips: Tip = smsVerficationTips;
  handleSMSSwitch(status: boolean) {
    if (this.xcxType === "mkb") {
      return;
    }
    // 普通用户不支持短信验证
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定",
      });
      return;
    }

    // 判断机构端是否已经开启了
    if (!status) {
      this.switchSMSVerify(status);
      return;
    }
    // 如果机构端开启了
    if (this.hasInstOpenSMSVerify) {
      // 如果余额大于0
      if (this.smsRemainNumber) {
        // 如果短信余额大于等于100
        if (this.smsRemainNumber >= 100) {
          this.switchSMSVerify(status);
        } else {
          Vue.$confirm({
            title: "短信余额预警",
            text: `<p style="color: #666; text-align: left;">当前<span style="color:#FF5953">${this.instNameFew.join(
              "、"
            )}</span>剩余可发送短信条数＜100条，为不影响此功能正常使用，请及时前往小麦助教网页端【短信管理】页充值短信数量。</p><br/>
                <p style="color: #888; text-align: left;">注意：开启短信验证后，若剩余可发送短信数为0，家长报名时，将不能获取验证码，<span style="color: #FF4F34">无法进行报名操作</span>，充值后短信验证功能可正常使用，机构可前往短信管理页面进行短信充值，或前往小麦秀活动编辑页面关闭短信验证功能。</p>`,
            okText: "开启功能",
            cancleText: "暂不开启",
            ok: () => {
              this.switchSMSVerify(status);
            },
            cancle: () => {
              this.$emit("cancle");
            },
          });
        }
      } else {
        Vue.$confirm({
          title: "短信余额不足提醒",
          text: `当前<span style="color:#FF5953">${this.instNameZero.join(
            "、"
          )}</span>剩余可发送短信条数为0，暂无法使用此功能，请及时前往小麦助教网页端【短信管理】页充值短信数量。 `,
          okText: "确定",
          cancleText: "暂不开启",
        });
      }
    } else {
      if (this.instNameNot.length === 0) {
        Vue.$confirm({
          title: "提示",
          text: "请联系相关主账号在网页端小麦助教【机构设置-短信管理】-发送设置中开启“小麦秀短信验证功能”",
          okText: "确定",
          cancleText: "暂不开启",
        });
      } else {
        Vue.$confirm({
          title: "提示",
          text: `当前<span style="color:#FF5953">${this.instNameNot.join(
            "、"
          )}</span>未开启小麦秀短信验证，无法开启短信验证功能。
          <div class="tipstext">提示:如需开启，请联系以上校区前往小麦助教【机构设置-规则设置-机构消息推送】页开启小麦秀短信验证。</div>`,
          okText: "确定",
          cancleText: "暂不开启",
        });
      }
    }
  }
}
